import React from 'react'
import PropTypes from 'prop-types'

import Layout from '@shared/components/layout'
import ReelMain from '@shared/components/reelSlider/reelMain'

function reels({ seoData, isMobileWebView }) {
  // setPreviewMode(true)
  return (
    <Layout data={{ oSeo: seoData }}>
      <ReelMain seoData={seoData} isMobileWebView={isMobileWebView} />
    </Layout>
  )
}
reels.propTypes = {
  seoData: PropTypes.object,
  isMobileWebView: PropTypes.bool
}
export default reels

export async function getServerSideProps({ req, res, params, query, resolvedUrl }) {
  res.setHeader('Cache-Control', 'public, max-age=1800')
  const [graphql, articleQuery] = await Promise.all([import('@shared-components/queryGraphql'), import('@graphql/article/article.query')])
  try {
    const { data } = await graphql?.default(articleQuery.GET_ARTICLE_ID, { input: { sSlug: 'video' } })
    return {
      props: {
        seoData: data?.getSeoData || null,
        bIsHideFooter: true,
        bIsHideHeader: true
      }
    }
  } catch (error) {
    return { notFound: true }
  }
}
